import React, { useEffect } from 'react';
import { GridCol, GridRow, Heading, IconSuccessAlert } from '@lmig/lmds-react';
import { authService } from '../../common/services';
import { trackCustomHeapEvent } from '../../../utils/heap';
import EmptySpace from '../../common/components/empty-space/empty-space-component';
import styles from './reset-mfa-success.module.scss';

const ResetMfaSuccess = () => {
  useEffect(() => {
    const timer = setTimeout(() => {
      trackCustomHeapEvent('mfa-reset-logout-redirect', {});
      authService.logout(); // Call logout after 5 seconds

    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <GridRow >
      <GridCol base={12} className={styles.mfaSuccessContainer}>
        <GridCol lg={6} xl={6}>
          <EmptySpace height={64} />
          <IconSuccessAlert size="64" className={styles.filledIcon} />
          <Heading type="h4-bold">Success! You have reset your multifactor authentication</Heading>
          <Heading type="h4-light">We’re logging you out of your online account. For safety, please log back in to set up multifactor authentication</Heading>
          <EmptySpace height={100} />
        </GridCol>
      </GridCol>
    </GridRow>
  );
};

export default ResetMfaSuccess;
